import { searchFormHelper } from './search-form';
import { formatter, translate } from './util';
import { procedureTag } from './procedure-tag';
import { procedureGroupHelper } from './procedure-group';
import { productGroupingHelper } from './product-grouping';
import { atcGroupGroupingHelper } from './atc-group-grouping';
import { referenceGroupGroupingHelper } from './reference-group-grouping';
import tippy from 'tippy.js';

/**
 * Shared features of procedures.
 */
var procedureHelper = (function ($) {
	/**
	 * Create procedure table rows from data.
	 *
	 * @param {{
	 *     items: {
	 *         id: string,
	 *         type: string,
	 *         fileNumber: string,
	 *         products: {
	 *             id: string,
	 *             code: string,
	 *             name: string,
	 *             nameSupplement: string,
	 *             nameWithNameSupplement: string
	 *         }[],
	 *         atcGroups: {
	 *             id: string,
	 *             code: string,
	 *             substance: string
	 *         }[],
	 *         referenceGroups: {
	 *             id: string,
	 *             code: string,
	 *             name: string
	 *         }[],
	 *         statuses: {
	 *             id: string,
	 *             name: string
	 *         }[],
	 *         started: string,
	 *         finished: string,
	 *         lastDocumentTime: string,
	 *         finishedTime: string,
	 *         deadline: {
	 *             name: string,
	 *             until: string
	 *         }
	 *     }[],
	 *     pagination:{
	 *         total:int,
	 *         perPage:int,
	 *         currentPage:int,
	 *         totalPages:int
	 *     }
	 * }} response Data returned from the server.
	 */
	var createProcedureTableRows = function (response) {
		$('.procedure-table .table').toggle(response.pagination.total > 0);
		$('.procedure-table .load-more').toggle(response.pagination.currentPage < response.pagination.totalPages);
		$('.procedure-table .no-results-container').toggle(response.pagination.total === 0);

		for (var i = 0; i < response.items.length; i++) {
			createProcedureTableRow(response.items[i]);
		}

		tippy('.tooltip');
	};

	/**
	 * Create procedure table row.
	 *
	 * @param {{
	 *     id: string,
	 *     type: string,
	 *     fileNumber: string,
	 *     products: {
	 *         id: string,
	 *         code: string,
	 *         name: string,
	 *         nameSupplement: string,
	 *         nameWithNameSupplement: string
	 *     }[],
	 *     atcGroups: {
	 *         id: string,
	 *         code: string,
	 *         substance: string
	 *     }[],
	 *     referenceGroups: {
	 *         id: string,
	 *         code: string,
	 *         name: string
	 *     }[],
	 *     statuses: {
	 *         id: string,
	 *         name: string
	 *     }[],
	 *     started: string,
	 *     finished: string,
	 *     lastDocumentTime: string,
	 *     deadline: {
	 *         name: string,
	 *         until: string
	 *     },
	 *     tags: {
	 *         id: string,
	 *         procedureId: string,
	 *         tag: {
	 *             id: string,
	 *             userId: string,
	 *             name: string,
	 *             color: string
	 *         }
	 *     }
	 * }} procedure Definition of the procedure.
	 */
	var createProcedureTableRow = function (procedure) {
		var tableRow = $('<tr>');
		var detailUrl = location.pathname + '/' + encodeURIComponent(procedure.id) + location.search;
		var detailLink = $('<a class="btn-detail">').attr('href', detailUrl).text('detail');

		tableRow.append(
			$('<td class="no-padding">').html(
				'<p class="p-small">' + procedure.fileNumber + '</p>' + '<p><strong>' + procedure.type + '</strong></p>'
			)
		);
		tableRow.append($('<td>').append(generateProducts(procedure.products, detailUrl)));
		tableRow.append($('<td>').append(generateAtcGroups(procedure.atcGroups, detailUrl)));
		tableRow.append($('<td>').append(generateReferenceGroups(procedure.referenceGroups, detailUrl)));
		tableRow.append($('<td>').text(procedure.started ? formatter.formatDate(procedure.started) : '-'));
		tableRow.append($('<td>').text(procedure.finished ? formatter.formatDate(procedure.finished) : '-'));
		tableRow.append(
			$('<td>').text(procedure.lastDocumentTime ? formatter.formatDateTime(procedure.lastDocumentTime) : '-')
		);
		tableRow.append($('<td>').html(getValueOrCount(procedure.statuses, 'name', 'status')));
		tableRow.append($('<td class="item-tag">').html(buildTags(procedure)));
		tableRow.append($('<td class="item-last">').html(detailLink));
		tableRow.clickableRow('btn-detail');

		$('.table tbody').append(tableRow);
		procedureTag.initSelect(tableRow.find('select.add-tag-select'));
	};

	var buildTags = function (procedure) {
		var procedureTags = procedure.tags;

		var select = $('<select name="tag" class="add-tag-select">');
		var input = $('<input type="hidden" name="procedureId">').attr('value', procedure.id);
		var button = $('<button class="btn btn-addtag">').text('Přidat');

		var form = $('<form class="search-add-procedure-tag add-procedure-tag-form">')
			.append(select)
			.append(input)
			.append(button);

		var formAddTag = $('<div class="form-add-tag">').append(form);
		var itemTableTagContent = $('<div class="item-table-tag-content">').append(formAddTag);

		var container = $('<div class="item-tag-content">');
		var tagForm = $('<div class="item-table-tag">');
		var pTags = $('<p>').addClass('p-tags');
		tagForm.append('<a href="javascript:;" class="add-tag">+</a>');

		var tagsList = $('<div class="tags-list">');

		for (var i = 0; i < procedureTags.length; i++) {
			var procedureTag = procedureTags[i];

			var tagUrl = '/search?filter-tag=' + encodeURIComponent(procedureTag.tag.id);
			var tagLink = $('<a class="btn-tag-item">').text(procedureTag.tag.name).attr('href', tagUrl);
			var tagDeleteLink = $('<a href="javascript:;" class="btn-remove-tag"></a>')
				.attr('data-procedure-tag-id', procedureTag.id)
				.attr('data-procedure-id', procedureTag.procedureId);
			var p = $('<p class="p-tag">').append(tagLink).append(tagDeleteLink);

			let tagSpan = $('<span>')
				.attr('data-procedure-tag-id', procedureTag.id)
				.attr('data-procedure-id', procedureTag.procedureId)
				.append(
					$('<i>')
						.addClass('i-' + procedureTag.tag.color)
						.text(procedureTag.tag.name)
				);
			pTags.append(tagSpan);

			tagsList.append(p);
		}

		if (procedureTags.length === 0) {
			container.addClass('item-tag-content-empty');
		}

		itemTableTagContent.append(tagsList);
		tagForm.append(itemTableTagContent);

		return container.append(tagForm).append(pTags);
	};

	var getProducts = function (values, textProperty, formsClass) {
		if (values.length === 0) {
			return '-';
		}

		let result = getSingleValue(values[0], textProperty);

		if (values.length === 1) {
			return result;
		}

		if (values.length === 2) {
			return result + ', ' + getSingleValue(values[1], textProperty);
		}

		let translatedProducts = translate.selectForm($('.table th.' + formsClass).data(), values.length - 1);
		return (
			result +
			' <span data-tippy-content="' +
			groupProductsByName(values) +
			'" class="tooltip">+' +
			(values.length - 1) +
			'&nbsp;' +
			translatedProducts +
			'</span>'
		);
	};

	let generateProducts = function (products, detailUrl) {
		let productsGroupingResult = productGroupingHelper.createProductGroupingResult(products);
		let productsDescription = $('<span>').addClass('truncate').text(productsGroupingResult.getDescription());

		if (!productsGroupingResult.hasTooltip()) {
			return $('<span>').append(productsDescription);
		}

		let tooltip = $('<a>')
			.addClass('tooltip')
			.attr('href', detailUrl + '#products')
			.text('(' + productsGroupingResult.getNote() + ')')
			.attr('data-tippy-content', productsGroupingResult.getNoteTooltip());

		return $('<span>').append(productsDescription).append(tooltip);
	};

	let generateAtcGroups = function (atcGroups, detailUrl) {
		let atcGroupsGroupingResult = atcGroupGroupingHelper.createAtcGroupGroupingResult(atcGroups);
		let atcGroupsDescription = $('<span>').addClass('truncate').text(atcGroupsGroupingResult.getDescription());

		if (!atcGroupsGroupingResult.hasTooltip()) {
			return $('<span>').append(atcGroupsDescription);
		}

		let tooltip = $('<a>')
			.addClass('tooltip')
			.attr('href', detailUrl + '#products')
			.text('(' + atcGroupsGroupingResult.getNote() + ')')
			.attr('data-tippy-content', atcGroupsGroupingResult.getNoteTooltip());

		return $('<span>').append(atcGroupsDescription).append(tooltip);
	};

	let generateReferenceGroups = function (referenceGroups, detailUrl) {
		let referenceGroupsGroupingResult =
			referenceGroupGroupingHelper.createReferenceGroupGroupingResult(referenceGroups);
		let referenceGroupsDescription = $('<span>')
			.addClass('truncate')
			.text(referenceGroupsGroupingResult.getDescription());

		if (!referenceGroupsGroupingResult.hasTooltip()) {
			return $('<span>').append(referenceGroupsDescription);
		}

		let tooltip = $('<a>')
			.addClass('tooltip')
			.attr('href', detailUrl + '#products')
			.text('(' + referenceGroupsGroupingResult.getNote() + ')')
			.attr('data-tippy-content', referenceGroupsGroupingResult.getNoteTooltip());

		return $('<span>').append(referenceGroupsDescription).append(tooltip);
	};

	var groupProductsByName = function (values) {
		let items = {};

		for (let i = 1; i < values.length; i++) {
			let name = values[i]['name'];

			if (name in items) {
				items[name]++;
			} else {
				items[name] = 1;
			}
		}

		let strings = [];

		for (var name in items) {
			strings.push(name + ' (' + items[name] + ')');
		}

		return strings;
	};

	var getValueOrCount = function (values, textProperty, formsClass, titleProperty) {
		if (values.length === 0) {
			return '-';
		}

		if (values.length === 1) {
			return getSingleValue(values[0], textProperty, titleProperty);
		}

		if (values.length === 2) {
			return (
				getSingleValue(values[0], textProperty, titleProperty) +
				', ' +
				getSingleValue(values[1], textProperty, titleProperty)
			);
		}

		return (
			getSingleValue(values[0], textProperty, titleProperty) +
			' +' +
			(values.length - 1) +
			'&nbsp;' +
			translate.selectForm($('.table th.' + formsClass).data(), values.length - 1)
		);
	};

	var getSingleValue = function (value, textProperty, titleProperty) {
		if (titleProperty) {
			return '<span title="' + value[titleProperty] + '">' + value[textProperty] + '</span>';
		} else {
			return value[textProperty];
		}
	};

	var getProceduresApiUrl = function () {
		var values = searchFormHelper.getSearchFormValues();
		var operator = searchFormHelper.getOperatorValue();
		var withProductBrothers = searchFormHelper.isWithProductBrothers();
		var queryString = '';

		for (var i = 0; i < values.length; i++) {
			queryString +=
				(i === 0 ? '?' : '&') + encodeURIComponent(values[i].name) + '=' + encodeURIComponent(values[i].value);
		}

		queryString +=
			(queryString === '' ? '?' : '&') +
			'operator=' +
			encodeURIComponent(operator) +
			'&with-product-brothers=' +
			withProductBrothers;

		return '/procedures' + queryString;
	};

	return {
		createProcedureTableRows: createProcedureTableRows,
		getProceduresApiUrl: getProceduresApiUrl,
	};
})(jQuery);

/**
 * Features of procedure search.
 */
var procedureSearch = (function ($) {
	var root;

	var init = function () {
		root = $('.procedure-search');

		if (root.length === 0) {
			return;
		}

		var datagrid = {
			page: 1,
			order: searchFormHelper.getOrderValue() || 'default',
			sortDirection: searchFormHelper.getSortDirectionValue() || 'asc',
		};

		root.find('.search-form-container').searchForm();
		root.find('.btn-create-procedure-group').createProcedureGroupModal('.create-procedure-group-modal');
		root.find('.table tbody tr').clickableRow('btn-detail');
		root
			.find('.procedure-table .btn-load-more')
			.loadMoreWithSort(procedureHelper.getProceduresApiUrl(), procedureHelper.createProcedureTableRows, datagrid);

		$(document).on('procedureGroup.created', saveProcedureGroupFilters);
	};

	var saveProcedureGroupFilters = function (event, response) {
		procedureGroupHelper.createSaveFiltersApiRequest(response.procedureGroup.id).done(function () {
			procedureGroupHelper.redirectToProcedureGroupDetail(event, response);
		});
	};

	return {
		init: init,
	};
})(jQuery);

/**
 * Features of procedure detail.
 */
var procedureDetail = (function ($) {
	var init = function () {
		var root = $('.procedure-detail');

		if (root.length === 0) {
			return;
		}

		root.find('.detail-tabs a').tabs('.tab-content', 'item-act');
		root.find('.tab-content[data-tab=documents] tbody tr').clickableRow('btn-detail');
		root.find('.tab-content[data-tab=amalgamations] tbody tr').clickableRow('btn-detail');
		root
			.find('.tab-content[data-tab=documents] .btn-detail')
			.toggleTableDetails('.table-item-showmore', 'table-item-act');
	};

	return {
		init: init,
	};
})(jQuery);

export { procedureHelper, procedureSearch, procedureDetail };
